/* global document */
import { setTargetComponentTimeline } from 'Renderer/domOperations/animationOperations';
import { showButtonSet, hideButtonSet } from 'Renderer/utils/buttonScript';
import {
  extractTargetComponents,
  showComponents,
  hideComponents,
  showRemoteComponents,
  hideRemoteComponents,
  handleSwitchArtboard,
  videoControlCarousel,
  handleVideoEndPlayVideo,
} from 'Renderer/domOperations/actionOperations';
import {
  AUTO_PLAY_VIDEO_CLASS,
  PLAY_VIDEO_BUTTON_CLASS,
  REPLAY_VIDEO_BUTTON_CLASS,
  PAUSE_VIDEO_BUTTON_CLASS,
  MUTE_VIDEO_BUTTON_CLASS,
  UNMUTE_VIDEO_BUTTON_CLASS,
  VIDEO_END_SWITCH_ARTBOARD,
  VIDEO_END_SHOW_COMPONENT,
  VIDEO_END_HIDE_COMPONENT,
  VIDEO_END_CAROUSEL_GROUP,
  VIDEO_END_PLAY_VIDEO,
  VIDEO_END_SHOW_REMOTE_COMPONENT,
  VIDEO_END_HIDE_REMOTE_COMPONENT,
  VIDEO_START_SHOW_COMPONENT,
  VIDEO_START_HIDE_COMPONENT,
  VIDEO_START_SHOW_REMOTE_COMPONENT,
  VIDEO_START_HIDE_REMOTE_COMPONENT
} from 'Tracking/constants/selectors';

export const initialiseVideoActions = () => {
  const { rootElement } = store.getState(); // eslint-disable-line no-undef

  [...rootElement.querySelectorAll(`.${VIDEO_END_SWITCH_ARTBOARD}`)].map((v) => {
    const dataArtboard = v.getAttribute('data-end-switchartboard-target') || '';
    v.removeEventListener('ended', () => handleSwitchArtboard(null, dataArtboard));
    v.addEventListener('ended', () => handleSwitchArtboard(null, dataArtboard));
  });
  [...rootElement.querySelectorAll(`.${VIDEO_END_CAROUSEL_GROUP}`)].map((v) => {
    v.removeEventListener('ended', evt => videoControlCarousel(evt));
    v.addEventListener('ended', evt => videoControlCarousel(evt));
  });
  [...rootElement.querySelectorAll(`.${VIDEO_END_PLAY_VIDEO}`)].map((v) => {
    v.currentTime = 0;
    v.removeEventListener('ended', evt => handleVideoEndPlayVideo(evt));
    v.addEventListener('ended', evt => handleVideoEndPlayVideo(evt));
  });
  [...rootElement.querySelectorAll(`.${VIDEO_END_SHOW_COMPONENT}`)].map((v) => {
    const targetComponents = v.getAttribute('data-end-show-target').split(',');
    const transitionEffect = v.getAttribute('data-end-show-transition');
    if (targetComponents) {
      v.removeEventListener('ended', (evt) => showComponents(evt, targetComponents, transitionEffect));
      v.addEventListener('ended', (evt) => showComponents(evt, targetComponents, transitionEffect));
    }
  });
  [...rootElement.querySelectorAll(`.${VIDEO_END_HIDE_COMPONENT}`)].map((v) => {
    const targetComponents = v.getAttribute('data-end-hide-target').split(',');
    const transitionEffect = v.getAttribute('data-end-hide-transition');
    if (targetComponents) {
      v.removeEventListener('ended', (evt) => hideComponents(evt, targetComponents, transitionEffect));
      v.addEventListener('ended', (evt) => hideComponents(evt, targetComponents, transitionEffect));
    }
  });
  [...rootElement.querySelectorAll(`.${VIDEO_END_SHOW_REMOTE_COMPONENT}`)].map((v) => {
    const targetComponents = v.getAttribute('data-end-show-remote-target').split(',');
    const transitionEffect = v.getAttribute('data-end-show-remote-transition');
    if (targetComponents) {
      v.removeEventListener('ended', () => showRemoteComponents(targetComponents, transitionEffect));
      v.addEventListener('ended', () => showRemoteComponents(targetComponents, transitionEffect));
    }
  });
  [...rootElement.querySelectorAll(`.${VIDEO_END_HIDE_REMOTE_COMPONENT}`)].map((v) => {
    const targetComponents = v.getAttribute('data-end-hide-remote-target').split(',');
    const transitionEffect = v.getAttribute('data-end-hide-remote-transition');
    if (targetComponents) {
      v.removeEventListener('ended', () => hideRemoteComponents(targetComponents, transitionEffect));
      v.addEventListener('ended', () => hideRemoteComponents(targetComponents, transitionEffect));
    }
  });
  [...rootElement.querySelectorAll(`.${VIDEO_START_SHOW_COMPONENT}`)].map((v) => {
    const targetComponents = v.getAttribute('data-start-show-target').split(',');
    const transitionEffect = v.getAttribute('data-start-show-transition');
    if (targetComponents) {
      v.removeEventListener('play', (evt) => showComponents(evt, targetComponents, transitionEffect));
      v.addEventListener('play', (evt) => showComponents(evt, targetComponents, transitionEffect));
    }
  });
  [...rootElement.querySelectorAll(`.${VIDEO_START_HIDE_COMPONENT}`)].map((v) => {
    const targetComponents = v.getAttribute('data-start-hide-target').split(',');
    const transitionEffect = v.getAttribute('data-start-hide-transition');
    if (targetComponents) {
      v.removeEventListener('play', (evt) => hideComponents(evt, targetComponents, transitionEffect));
      v.addEventListener('play', (evt) => hideComponents(evt, targetComponents, transitionEffect));
    }
  });
  [...rootElement.querySelectorAll(`.${VIDEO_START_SHOW_REMOTE_COMPONENT}`)].map((v) => {
    const targetComponents = v.getAttribute('data-start-show-remote-target').split(',');
    const transitionEffect = v.getAttribute('data-start-show-remote-transition');
    if (targetComponents) {
      v.removeEventListener('ended', () => showRemoteComponents(targetComponents, transitionEffect));
      v.addEventListener('ended', () => showRemoteComponents(targetComponents, transitionEffect));
    }
  });
  [...rootElement.querySelectorAll(`.${VIDEO_START_HIDE_REMOTE_COMPONENT}`)].map((v) => {
    const targetComponents = v.getAttribute('data-start-hide-remote-target').split(',');
    const transitionEffect = v.getAttribute('data-start-hide-remote-transition');
    if (targetComponents) {
      v.removeEventListener('ended', () => hideRemoteComponents(targetComponents, transitionEffect));
      v.addEventListener('ended', () => hideRemoteComponents(targetComponents, transitionEffect));
    }
  });
};

export const initialiseVideoControls = () => {
  const { rootElement } = store.getState();
  [...rootElement.querySelectorAll(`.${PLAY_VIDEO_BUTTON_CLASS}`)].map((b) => {
    const targetComponent = b.getAttribute('data-video-play-target');
    const domElement = rootElement.querySelector(`.${targetComponent} video`);
    if (!domElement) return null;
    if (domElement.classList.contains(`${AUTO_PLAY_VIDEO_CLASS}`)) {
      domElement.addEventListener('play', () => hideButtonSet(b, 'play'));
    }
    const replay = rootElement.querySelector(`[data-video-replay-target='${targetComponent}']`);
    if (!replay) {
      domElement.addEventListener('ended', () => showButtonSet(b, 'play'));
    }
    domElement.addEventListener('pause', (e) => {
      const completed = (e.target.currentTime === e.target.duration) && (e.target.readyState !== 1);
      if ((!replay && !completed) || (replay && !completed)) showButtonSet(b, 'play');
    });
  });
  [...rootElement.querySelectorAll(`.${REPLAY_VIDEO_BUTTON_CLASS}`)].map((b) => {
    const targetComponent = b.getAttribute('data-video-replay-target');
    const domElement = rootElement.querySelector(`.${targetComponent} video`);
    if (!domElement) return null;
    hideButtonSet(b, 'replay');
    domElement.addEventListener('play', () => hideButtonSet(b, 'replay'));
    domElement.addEventListener('ended', () => showButtonSet(b, 'replay'));
  });
  [...rootElement.querySelectorAll(`.${PAUSE_VIDEO_BUTTON_CLASS}`)].map(b => {
    const targetComponent = b.getAttribute('data-video-pause-target');
    const domElement = rootElement.querySelector(`.${targetComponent} video`);
    if (!domElement) return null;
    hideButtonSet(b, 'pause');
    domElement.addEventListener('play', () => showButtonSet(b, 'pause'));
    domElement.addEventListener('ended', () => hideButtonSet(b, 'pause'));
    domElement.addEventListener('pause', () => hideButtonSet(b, 'pause'));
  });
  [...rootElement.querySelectorAll(`.${MUTE_VIDEO_BUTTON_CLASS}`)].map(b => {
    const targetComponents = b.getAttribute('data-video-mute-target');
    const domElements = extractTargetComponents(b, targetComponents, 'video');
    [...domElements].forEach((domElement) => {
      if (!domElement) return null;
      if (domElement.muted) { hideButtonSet(b, 'mute'); }
    });
  });
  [...rootElement.querySelectorAll(`.${UNMUTE_VIDEO_BUTTON_CLASS}`)].map(b => {
    const targetComponents = b.getAttribute('data-video-unmute-target');
    const domElements = extractTargetComponents(b, targetComponents, 'video');
    [...domElements].forEach((domElement) => {
      if (!domElement) return null;
      if (!domElement.muted) { hideButtonSet(b, 'unmute'); }
    });
  });
};



// WEBPACK FOOTER //
// ./app/javascript/renderer/domOperations/videoOperations.js